import React from 'react';
import { connect } from 'react-redux';
import { checkMot } from '../../ressources/functionJS/checkMot';
import styles from './AccueilDashboard.module.scss';
import { mockAccueilData } from './mockDataAccueil';

// Import des widgets
import {
  WidgetProjets,
  WidgetAlarmes,
  WidgetContact,
  WidgetRapports,
  WidgetCommentCaMarche,
  WidgetWidgetsLayout,
} from './widgets';

// Composant principal AccueilDashboard
const AccueilDashboard = (props) => {
  // Utiliser les données mock
  const summary = mockAccueilData.summary;
  const alarmesList = summary.alarmes || [];
  const rapportsList = summary.rapports || [];
  const dashboardsList = summary.dashboard ? [summary.dashboard] : [];
  const graphesFavorisList = summary.graph ? [summary.graph] : [];
  const vuesFavoritesList = summary.views || [summary.view] || [];
  const projectsListSummary = mockAccueilData.projects || [];

  return (
    <div className={styles.dashboard}>
      <div className={styles.bienvenue}>
        {checkMot('bienvenue')} <b>{props.prenom}</b> {checkMot('sur_la_platforme_argos')}
      </div>
      <div className={styles.widgetsGrid}>
        <WidgetWidgetsLayout
          dashboards={dashboardsList}
          vuesFavorites={vuesFavoritesList}
          graphesFavoris={graphesFavorisList}
        />
        <div className={[styles.area, styles.projetsArea].join(' ')}>
          <WidgetProjets
            projects={projectsListSummary}
            favoriteProjectIds={
              mockAccueilData.projects
                .filter((p) => p.favorite)
                .map((p) => p.project_id) || []
            }
          />
        </div>
        <div className={[styles.area, styles.midArea].join(' ')}>
          <div className={styles.midGrid}>
            <div className={styles.midTop}>
              <WidgetAlarmes alarmes={alarmesList} />
            </div>
            <div className={styles.midBottom}>
              <WidgetRapports rapports={rapportsList} />
            </div>
          </div>
        </div>
        <div className={[styles.area, styles.rightArea].join(' ')}>
          <div className={styles.rightGrid}>
            <div className={styles.rightTop}>
              <WidgetContact />
            </div>
            <div className={styles.rightBottom}>
              <WidgetCommentCaMarche />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    prenom: state.authentifie.name,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AccueilDashboard);
